const SELECTORS = {
  item: ".js-yt-iframe-item",
  iframe: ".js-yt-iframe-iframe",
  wrapper: ".js-yt-iframe-wrapper",
  trigger: ".js-yt-iframe-trigger",
  close: ".js-yt-iframe-close",
};

class YoutubeIframe {
  constructor(context, delay = 0) {
    this.context = context;
    this.delay = delay;
    this.elements = this.context.querySelectorAll(SELECTORS.item);
  }

  initPlayer() {
    this.elements.forEach((element) => {
      const videoWrapper = element.querySelector(SELECTORS.wrapper);
      const videoTrigger = element.querySelector(SELECTORS.trigger);
      const videoClose = element.querySelector(SELECTORS.close);
      const vid = videoWrapper.dataset.videoId;
      const markupAppend = `<iframe
        class="js-yt-iframe-iframe"
        tabindex="0"
        src="https://www.youtube-nocookie.com/embed/${vid}?rel=0&amp;controls=1&amp;showinfo=0&amp;autoplay=1&amp;playsinline=1&amp;enablejsapi=1"
        frameborder="0"
        allow="autoplay; encrypted-media"
        allowfullscreen=""></iframe>
      `;

      videoTrigger.addEventListener("click", (event) => {
        event.preventDefault();

        setTimeout(() => {
          this.removeIframes();
          this.appendPlayer(videoWrapper, markupAppend, element);
        }, this.delay || 0);
      });

      videoClose.addEventListener("click", (event) => {
        event.preventDefault();

        this.removePlayer(videoWrapper);
      });
    });
  }

  appendPlayer(wrapper, markup, element) {
    wrapper.insertAdjacentHTML("beforeend", markup);
    element.dataset.loaded = 1;
  }

  removeIframes() {
    this.elements.forEach((section) => {
      const iframe = section.querySelector(SELECTORS.iframe);

      if (iframe) {
        iframe.parentNode.removeChild(iframe);
        section.dataset.loaded = 0;
      }
    });
  }

  removePlayer(wrapper) {
    wrapper.innerHTML = "";
    wrapper.parentNode.dataset.loaded = 0;
  }
}

export { YoutubeIframe };
